<template>
  <v-container class="py-0">
    <v-row>
      <v-col cols="12" sm="6">
        <h2>{{ $t("meter-units.meter-path") }}</h2>
        <p class="ma-0">
          <template v-for="i in meter_unit.path">
            <router-link
              :to="{ name: i.to, params: i }"
              v-text="i.name"
              v-bind:key="'link' + i.to + i.id"
            ></router-link>
            <span v-bind:key="'span' + i.to + i.id" class="groups-arrow">
              <v-icon v-if="i.icon" class="mdi">{{ i.icon }}</v-icon>
              <template v-else>{{ i.divider || " > " }}</template>
            </span>
          </template>
        </p>
      </v-col>
      <v-col cols="12" sm="6">
        <h2>{{ $t("meter-units.unit") }}</h2>
        <p class="ma-0">{{ meter_unit.name }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "GeneralInformationTransmission",
  components: {},
  computed: {
    meter_unit: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/meterUnitStore/getItem"
        ];
      }
    }
  }
};
</script>

<style scoped>
.groups-arrow:last-of-type {
  display: none;
}
</style>
